import { Recording } from '@sparemin/api-sdk';
import { Map } from 'immutable';
import { denormalize } from 'normalizr';
import { createSelector } from 'reselect';
import { recordingSchema } from 'redux/middleware/api/recording-service/service';
import { State } from 'redux/types';
import { DeepImmutableMap } from 'types';

export const recordingsSelector = (state: State) =>
  state.getIn(['entities', 'recordings']);

export const recordingsByIdSelector = createSelector(
  [recordingsSelector],
  (recordings): DeepImmutableMap<Record<string, Recording>> =>
    denormalize(recordings, recordingSchema, Map()),
);

export const recordingSelector = createSelector(
  recordingsByIdSelector,
  (_, id: string | number) => id,
  (recordingsById, id) => {
    if (!recordingsById || !id) {
      return undefined;
    }

    return recordingsById.get(String(id))?.toJS() as Recording | undefined;
  },
);
